// extracted by mini-css-extract-plugin
export default {"card":"Card_card__BkdIM","flexRow":"Card_flexRow__JQzbT","flexRowReverse":"Card_flexRowReverse__5caBp","cardImg":"Card_cardImg__PBcM4","cardTxt":"Card_cardTxt__YSd7Y"};